/* eslint-disable */
export default {
  title: 'Audio',
  dialButtonVolume: 'Volume pulsante di chiamata',
  ringtoneVolume: 'Volume suoneria',
  callVolume: 'Volume chiamata',
  muteCalls: 'Disattiva audio chiamate',
  outputDevice: 'Dispositivo di uscita',
  inputDevice: 'Dispositivo di ingresso',
  micPermission: 'Autorizzazione microfono',
  noDevice: 'Nessun dispositivo',
  checkMicPermission: 'Controlla autorizzazione',
  micNoPermissionMessage: "L'app non è autorizzata a usare il microfono",
  noLabel: 'Dispositivo sconosciuto',
  notSetSinkIdTip:
    "Le attuali autorizzazioni del browser non sono impostate per consentire l'accesso ai dispositivi di input audio. {clickHereLink} per la configurazione.",
  noLabelTip:
    "Le attuali autorizzazioni del browser non sono impostate per consentire l'accesso ai dispositivi di input audio.",
  clickHere: 'Fai clic qui',
  defaultOutputDevice: 'Dispositivo di output predefinito',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
